import React, { useEffect, useState } from 'react';
import Config from '../../config/Config';
import Pollytts from '../../utils/Pollytts';
import { connect } from 'react-redux';
import { fetchAttempt } from '../../redux/myCourse/myCourse.actions';
import {
	startAttempt,
	setShowReview,
} from '../../redux/testPage/testPage.actions';
import { formatDate } from '../../utils/commonFunctions';
import Modal from 'react-bootstrap/Modal';

import Row from 'react-bootstrap/Row';

const ReviewAttemptModal = ({
	setShowReview,
	showReview,
	instrDetails: { reviewAnswers, elementName, reviewAttemptId },
	reviewAttemptDetails: {
		l_level_range,
		r_level_range,
		w_level_range,
		s_level_range,
		o_level_range,
		l_level,
		r_level,
		w_level,
		s_level,
		o_level,
		attempt_name,
	},
	reviewAttemptDetails,
	fetchAttempt,
}) => {
	const getScore = (score, isFreeCourse, range) => {
		return isFreeCourse
			? range
			: parseFloat(Math.round(score * 100) / 100).toFixed(1);
	};

	const getTTS = (reviewAnswers) => {
		var Polly_settings = {
			awsRegion: 'ap-southeast-1',
			pollyVoiceId: 'Raveena',
			cacheSpeech: true,
		};

		var TTS = Pollytts(Polly_settings);

		var Answers = reviewAnswers;
		if (typeof Answers !== 'undefined') {
			// eslint-disable-next-line
			Object.keys(Answers).map(function (answerKey) {
				if (
					Answers[answerKey].question.type === 'Cloze_with_passage' ||
					Answers[answerKey].question.type === 'Cloze_with_conversation'
				) {
					if (
						Answers[answerKey].answers.score < 0.5 &&
						Answers[answerKey].answers.score >= 0
					) {
						var cloze_answer = Answers[answerKey].question.correct_answer_1.replace(
							/<[^>]+>/g,
							'',
						);
						// eslint-disable-next-line
						cloze_answer.split('#').map((val, key) => {
							TTS.getAudioUrl(
								val,
								Polly_settings.pollyVoiceId,
								'correct_ans_' + Answers[answerKey].question.question_id + '_' + key,
							);
						});
					}
				} else if (
					typeof Answers[answerKey].answers.karaoke_answer !== undefined &&
					Answers[answerKey].answers.karaoke_answer !== null
				) {
					var karaoke_answer = JSON.parse(Answers[answerKey].answers.karaoke_answer);
					// eslint-disable-next-line
					Object.keys(karaoke_answer).map(function (VKanswer_key) {
						var currentLoop = karaoke_answer[VKanswer_key];
						var karaoke_details = JSON.parse(
							Answers[answerKey].question.karaoke_details,
						);
						if (currentLoop.score === 0) {
							TTS.getAudioUrl(
								karaoke_details[VKanswer_key].text,
								Polly_settings.pollyVoiceId,
								'correct-answer-' +
									Answers[answerKey].answers.question_id +
									'-' +
									VKanswer_key,
							);
						}
					});
				} else if (Answers[answerKey].answers.file_url !== '') {
					if (
						Answers[answerKey].answers.score === 0 &&
						!!Answers[answerKey].question.correct_answer_1
					) {
						TTS.getAudioUrl(
							Answers[answerKey].question.correct_answer_1,
							Polly_settings.pollyVoiceId,
							'correct-answer-' + Answers[answerKey].question.question_id,
						);
					}
				}
			});
		}
	};

	const [answerList, setAnswerList] = useState('');

	const [onNext, setOnClickNext] = useState({ onClick: () => {} });
	const [onPrev, setOnClickPrev] = useState({ onClick: () => {} });
	const [nextClass, setNextClass] = useState('next_arrow');
	const [prevClass, setPrevClass] = useState('prev_arrow');

	const [wrongAnswers, setWrongAnswers] = useState(0);
	const [correctAnswers, setCorrectAnswers] = useState(0);
	const [ungradeAnswers, setUngradeAnswers] = useState(0);

	const [totalAnswers, setTotalAnswers] = useState(0);
	const [testDate, setTestDate] = useState('');

	var l_quest = 0;
	var s_quest = 0;
	var r_quest = 0;
	var w_quest = 0;

	var headerRight = '';
	var AnswersList = '';
	var headerClass = 'formativetest-review-popup';

	var prev_review_attempt = false;
	var next_review_attempt = false;

	var Answers = reviewAnswers;
	var AttemptDetails = reviewAttemptDetails;

	useEffect(() => {
		let correctAnswers = 0;
		let wrongAnswers = 0;
		let ungradeAnswers = 0;

		var nextclass = 'next_arrow';
		var prevclass = 'prev_arrow';

		var onclickNext = { onClick: () => {} };
		var onclickPrev = { onClick: () => {} };

		if (
			typeof reviewAnswers !== 'undefined' &&
			typeof reviewAttemptDetails !== 'undefined'
		) {
			setTotalAnswers(Object.keys(reviewAnswers).length);

			const isFreeCourse = attempt_name === 'free';

			l_level = getScore(l_level, isFreeCourse, l_level_range);
			r_level = getScore(r_level, isFreeCourse, r_level_range);
			w_level = getScore(w_level, isFreeCourse, w_level_range);
			s_level = getScore(s_level, isFreeCourse, s_level_range);
			o_level = getScore(o_level, isFreeCourse, o_level_range);

			setTestDate(formatDate(AttemptDetails.start_time, 'DD MMM YYYY'));

			if (
				typeof AttemptDetails !== 'undefined' &&
				typeof reviewAttemptId !== 'undefined'
			) {
				var reviewAttemptCount = Object.keys(reviewAttemptId).length;
				Object.keys(reviewAttemptId).forEach(function (reviewID) {
					if (reviewAttemptId[reviewID] === AttemptDetails.attempt_id) {
						if (reviewID - 1 >= 0) {
							var prevReviewKey = reviewID - 1;
							prev_review_attempt = reviewAttemptId[prevReviewKey];
							onclickPrev = {
								onClick: () => {
									fetchAttempt(prev_review_attempt, true);
								},
							};
							setOnClickPrev(onclickPrev);
							prevclass = 'prev_arrow';
						} else {
							prevclass = 'prev_arrow_disable';
						}
						if (parseInt(reviewID, 10) + 1 < reviewAttemptCount) {
							var nextReviewKey = parseInt(reviewID, 10) + 1;
							next_review_attempt = reviewAttemptId[nextReviewKey];
							onclickNext = {
								onClick: () => {
									fetchAttempt(next_review_attempt, true);
								},
							};
							setOnClickNext(onclickNext);
							nextclass = 'next_arrow';
						} else {
							nextclass = 'next_arrow_disable';
						}
					}
				});
			}

			if (AttemptDetails.element_type === 'S') {
				headerRight = <div className="review-popup-score">{o_level} Score</div>;
				headerClass = 'summativetest-review-popup';
			} else if (AttemptDetails.element_type === 'F') {
				headerRight = <img src={Config.ASSETSPATH + '/img/board.png'} alt="" />;
				headerClass = 'formativetest-review-popup';
			} else if (AttemptDetails.element_type === 'W') {
				headerRight = <img src={Config.ASSETSPATH + '/img/video.png'} alt="" />;
				headerClass = 'formativetest-review-popup';
			} else if (AttemptDetails.element_type === 'D') {
				headerClass = 'formativetest-review-popup';
				headerRight = (
					<img src={Config.ASSETSPATH + '/img/video_pink.png'} alt="" />
				);
			}

			Answers = reviewAnswers;
			if (Object.keys(Answers).length > 0) {
				AnswersList = Object.keys(Answers).map(function (answerKey, index) {
					var yourAnswer = '';
					var gradedImage = '';
					// var AnswerFeedback   = '';
					if (
						AttemptDetails.element_type === 'W' ||
						AttemptDetails.element_type === 'D' ||
						AttemptDetails.element_type === 'F'
					) {
						if (Answers[answerKey].question.domain === 'L') {
							l_quest += 1;
						} else if (Answers[answerKey].question.domain === 'S') {
							s_quest += 1;
						} else if (Answers[answerKey].question.domain === 'R') {
							r_quest += 1;
						} else if (Answers[answerKey].question.domain === 'W') {
							w_quest += 1;
						}
					}
					if (
						Answers[answerKey].question.type === 'Cloze_with_passage' ||
						Answers[answerKey].question.type === 'Cloze_with_conversation'
					) {
						var user_ans_class = '';
						var user_ans_img = '';

						if (Answers[answerKey].answers.score >= 0.5) {
							gradedImage = 'review_correct';
							correctAnswers = correctAnswers + 1;
							user_ans_class = 'correct-ans';
							user_ans_img = 'answergreen.png';
						} else if (
							Answers[answerKey].answers.score < 0.5 &&
							Answers[answerKey].answers.score >= 0
						) {
							gradedImage = 'review_wrong';
							wrongAnswers = wrongAnswers + 1;
							user_ans_class = 'wrong-ans';
							user_ans_img = 'answerred.png';
						} else if (Answers[answerKey].answers.score === -1) {
							gradedImage = 'review_ungraded';
							ungradeAnswers = ungradeAnswers + 1;
							user_ans_class = 'ungraded-ans';
							user_ans_img = 'answerblue.png';
						}

						yourAnswer = Answers[answerKey].answers.file_url
							.split('|')
							.map((val, key) => {
								return (
									<div className="progress-qbox">
										<div
											className={
												'col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop ' +
												user_ans_class
											}
										>
											<span className="progress-ans-caption">Your Answer:</span>
											<span className="progress-ans">
												<img
													src={Config.ASSETSPATH + 'img/' + user_ans_img}
													className="audioicon"
													alt=""
												/>
												<audio src={val} controls controlsList="nodownload"></audio>
											</span>
										</div>
										{user_ans_class === 'wrong-ans' ? (
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop correct-ans">
												<span className="progress-ans-caption">Correct Answer:</span>
												<span className="progress-ans">
													<img
														src={Config.ASSETSPATH + 'img/answergreen.png'}
														className="audioicon"
														alt=""
													/>
													<audio
														src=""
														controls
														controlsList="nodownload"
														id={
															'correct_ans_' +
															Answers[answerKey].question.question_id +
															'_' +
															key
														}
													></audio>
												</span>
											</div>
										) : (
											''
										)}
									</div>
								);
							});
					} else if (
						typeof Answers[answerKey].answers.karaoke_answer !== undefined &&
						Answers[answerKey].answers.karaoke_answer !== null
					) {
						if (Answers[answerKey].answers.score === 1) {
							// correct answer
							gradedImage = 'review_correct';
							correctAnswers = correctAnswers + 1;
						} else if (Answers[answerKey].answers.score === 0) {
							// wrong answer
							gradedImage = 'review_wrong';
							wrongAnswers = wrongAnswers + 1;
						} else if (Answers[answerKey].answers.score === -1) {
							// ungraded question
							gradedImage = 'review_ungraded';
							ungradeAnswers = ungradeAnswers + 1;
						}
						var karaoke_answer = JSON.parse(
							Answers[answerKey].answers.karaoke_answer,
						);
						yourAnswer = Object.keys(karaoke_answer).map(function (VKanswer_key) {
							var currentLoop = karaoke_answer[VKanswer_key];
							var karaoke_details = JSON.parse(
								Answers[answerKey].question.karaoke_details,
							);
							if (currentLoop.score === 1) {
								// correct answer
								return (
									<div className="col-lg-11 col-md-11 col-sm-12 col-xs-12 progress-qbox-cont-t">
										<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop">
											<span className="progress-ans-caption">&nbsp;</span>
											<span className="progress-ans">
												<strong>{karaoke_details[VKanswer_key].text}</strong>
											</span>
										</div>
										<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop correct-ans">
											<span className="progress-ans-caption">Your Answer:</span>
											<span className="progress-ans">
												<img
													src={Config.ASSETSPATH + 'img/answergreen.png'}
													className="audioicon"
													alt=""
												/>
												<audio
													src={currentLoop.url}
													controls
													controlsList="nodownload"
												></audio>
											</span>
										</div>
									</div>
								);
							} else if (currentLoop.score === 0) {
								// wrong answer
								return (
									<div className="col-lg-11 col-md-11 col-sm-12 col-xs-12 progress-qbox-cont-t">
										<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop">
											<span className="progress-ans-caption">&nbsp;</span>
											<span className="progress-ans">
												<strong>{karaoke_details[VKanswer_key].text}</strong>
											</span>
										</div>
										<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop wrong-ans">
											<span className="progress-ans-caption">Your Answer:</span>
											<span className="progress-ans">
												<img
													src={Config.ASSETSPATH + 'img/answerred.png'}
													className="audioicon"
													alt=""
												/>
												<audio
													src={currentLoop.url}
													controls
													controlsList="nodownload"
												></audio>
											</span>
										</div>
										<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop correct-ans">
											<span className="progress-ans-caption">Correct Answer:</span>
											<span className="progress-ans">
												<img
													src={Config.ASSETSPATH + 'img/answergreen.png'}
													className="audioicon"
													alt=""
												/>
												<audio
													src=""
													controls
													controlsList="nodownload"
													id={
														'correct-answer-' +
														Answers[answerKey].answers.question_id +
														'-' +
														VKanswer_key
													}
												></audio>
											</span>
										</div>
									</div>
								);
							} else if (currentLoop.score === -1) {
								// ungraded question
								return (
									<div className="col-lg-11 col-md-11 col-sm-12 col-xs-12 progress-qbox-cont-t">
										<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop">
											<span className="progress-ans-caption">&nbsp;</span>
											<span className="progress-ans">
												{karaoke_details[VKanswer_key].text}
											</span>
										</div>
										<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop ungraded-ans">
											<span className="progress-ans-caption">Your Answer:</span>
											<span className="progress-ans">
												<img
													src={Config.ASSETSPATH + 'img/answerblue.png'}
													className="audioicon"
													alt=""
												/>
												<audio
													src={currentLoop.url}
													controls
													controlsList="nodownload"
												></audio>
											</span>
										</div>
									</div>
								);
							} else {
								return '';
							}
						});
					} else if (Answers[answerKey].answers.file_url !== '') {
						if (Answers[answerKey].answers.score >= 0.5) {
							gradedImage = 'review_correct';
							correctAnswers = correctAnswers + 1;
							yourAnswer = (
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop correct-ans">
									<span className="progress-ans-caption">Your Answer:</span>
									<span className="progress-ans">
										<img
											src={Config.ASSETSPATH + '/img/answergreen.png'}
											className="audioicon"
											alt=""
										/>
										<audio
											src={Answers[answerKey].answers.file_url}
											controls
											controlsList="nodownload"
										></audio>
									</span>
								</div>
							);
						} else if (Answers[answerKey].answers.score === 0) {
							gradedImage = 'review_wrong';
							wrongAnswers = wrongAnswers + 1;
							yourAnswer = (
								<div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop wrong-ans">
										<span className="progress-ans-caption">Your Answer Audio:</span>
										<span className="progress-ans">
											<img
												src={Config.ASSETSPATH + '/img/answerred.png'}
												className="audioicon"
												alt=""
											/>
											<audio
												src={Answers[answerKey].answers.file_url}
												controls
												controlsList="nodownload"
											></audio>
										</span>
									</div>
									{Answers[answerKey].question.type !== 'LA' && (
										<div className="correct-answer">
											<span>Correct Answer: </span>
											<span className="progress-ans">
												<img
													src={Config.ASSETSPATH + '/img/answergreen.png'}
													className="audioicon"
													alt=""
												/>
												<audio
													src=""
													controls
													controlsList="nodownload"
													id={'correct-answer-' + Answers[answerKey].question.question_id}
												></audio>
											</span>
										</div>
									)}
								</div>
							);
						} else if (Answers[answerKey].answers.score === -1) {
							gradedImage = 'review_ungraded';
							ungradeAnswers = ungradeAnswers + 1;
							yourAnswer = (
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop ungrade-ans">
									<span className="progress-ans-caption">Your Answer:</span>
									<span className="progress-ans">
										<img
											src={Config.ASSETSPATH + '/img/answerblue.png'}
											className="audioicon"
											alt=""
										/>
										<audio
											src={Answers[answerKey].answers.file_url}
											controls
											controlsList="nodownload"
										></audio>
									</span>
								</div>
							);
						}
					} else if (Answers[answerKey].question.type === 'CLOZE') {
						let userChoice = Answers[answerKey].answers.user_answer.includes('#')
							? Answers[answerKey].answers.user_answer.split('#')
							: [Answers[answerKey].answers.user_answer];
						let question = Answers[answerKey].question.source_text_or_html.split(
							'[blank]',
						);
						let correctChoice = Answers[
							answerKey
						].question.correct_answers[0].includes('#')
							? Answers[answerKey].question.correct_answers[0].split('#')
							: Answers[answerKey].question.correct_answers;
						let userAnswer = question.map((que, i) => {
							return que + (typeof userChoice[i] !== 'undefined' ? userChoice[i] : '');
						});
						let correctAnswer = question.map((que, i) => {
							return (
								que + (typeof correctChoice[i] !== 'undefined' ? correctChoice[i] : '')
							);
						});

						if (Answers[answerKey].answers.score > 0) {
							gradedImage = 'review_correct';
							correctAnswers = correctAnswers + 1;
							yourAnswer = (
								<div className={'your-answer-correct'}>
									<span>Your Answer: </span>
									<span
										dangerouslySetInnerHTML={{ __html: userAnswer.join(' ') }}
									></span>
								</div>
							);
						} else if (Answers[answerKey].answers.score === 0) {
							gradedImage = 'review_wrong';
							wrongAnswers = wrongAnswers + 1;
							yourAnswer = (
								<div>
									<div className={'your-answer-wrong'}>
										<span>Your Answer: </span>
										<span
											dangerouslySetInnerHTML={{ __html: userAnswer.join(' ') }}
										></span>
									</div>
									<div className="correct-answer">
										<span>Correct Answer: </span>
										<span
											dangerouslySetInnerHTML={{ __html: correctAnswer.join(' ') }}
										></span>
									</div>
								</div>
							);
						} else if (Answers[answerKey].answers.score === -1) {
							gradedImage = 'review_ungraded';
							ungradeAnswers = ungradeAnswers + 1;
							yourAnswer = (
								<div className="your-answer-ungraded">
									<span>Your Answer: </span>
									<span
										dangerouslySetInnerHTML={{ __html: userAnswer.join(' ') }}
									></span>
								</div>
							);
						}
					} else {
						if (Answers[answerKey].answers.score >= 0.5) {
							gradedImage = 'review_correct';
							correctAnswers = correctAnswers + 1;
							yourAnswer = (
								<div className={'your-answer-correct'}>
									<span>Your Answer: </span>
									<span
										dangerouslySetInnerHTML={{
											__html: Answers[answerKey].answers.user_answer,
										}}
									></span>
								</div>
							);
						} else if (Answers[answerKey].answers.score === 0) {
							gradedImage = 'review_wrong';
							wrongAnswers = wrongAnswers + 1;

							let userAnswer = Answers[answerKey].answers.user_answer;
							let correctAnswer = Answers[answerKey].question.correct_answer_1;
							let userAnswerList = userAnswer.split('|');

							let answerList = userAnswerList.map((ans, index) => {
							if(Answers[answerKey].question.type == 'LA') {
								return (
									<span className={'your-answer-wrong'} dangerouslySetInnerHTML={{
													__html: userAnswer,
												}}
									></span>
								);

							} else {
								if (correctAnswer.includes(ans.trim())) {
									return (
										<span className={'your-answer-correct'}>
											{ans} <span>{index < userAnswerList.length - 1 ? '|' : ''}</span>
										</span>
									);
								} else {
									return (
										<span className={'your-answer-wrong'}>
											{ans} <span>{index < userAnswerList.length - 1 ? '|' : ''}</span>
										</span>
									);
								}
							}
							});
							yourAnswer = (
								<div>
									<div className={'your-answer-wrong'}>
										<span>Your Answer: </span>
										 {answerList}
									</div>
									{Answers[answerKey].question.type !== 'LA' && (
										<div className="correct-answer">
											<span>Correct Answer: </span>
											<span
												dangerouslySetInnerHTML={{
													__html: Answers[answerKey].question.correct_answer_1,
												}}
											></span>
										</div>
									)}
								</div>
							);
						} else if (Answers[answerKey].answers.score === -1) {
							gradedImage = 'review_ungraded';
							ungradeAnswers = ungradeAnswers + 1;
							yourAnswer = (
								<div className="your-answer-ungraded">
									<span>Your Answer: </span>
									<span
										dangerouslySetInnerHTML={{
											__html: Answers[answerKey].answers.user_answer,
										}}
									></span>
								</div>
							);
						}
					}
					var default_feedback = '';
					if (
						Answers[answerKey].question.default_feedback !== '' &&
						Object.keys(Answers[answerKey].question.default_feedback).length <= 0
					) {
						default_feedback = (
							<div className="clearfix col-lg-12 col-md-12 col-xs-12 ans-exp-box">
								<span className="progress-ans">
									<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 answer-loop">
										<span className="progress-ans-caption" style={{ fontWeight: 'bold' }}>
											Feedback:
										</span>
										<span className="progress-ans">
											{Answers[answerKey].question.default_feedback}
										</span>
									</div>
								</span>
							</div>
						);
					}
					return (
						<div className="col-lg-12 col-xs-12 col-md-12 col-sm-12 review-answer-block">
							<div className="review-block-question-number">Q-{index + 1}</div>
							<div className="review-block-icon">
								<img src={Config.ASSETSPATH + '/img/' + gradedImage + '.png'} alt="" />
							</div>
							<div
								className="question-block"
								dangerouslySetInnerHTML={{
									__html: Answers[answerKey].question.question,
								}}
							></div>
							{yourAnswer}
							{default_feedback}
						</div>
					);
				});
			} else {
				AnswersList = 'No questions were answered in this test.';
			}
			setAnswerList(AnswersList);
			setCorrectAnswers(correctAnswers);
			setWrongAnswers(wrongAnswers);
			setUngradeAnswers(ungradeAnswers);
			setNextClass(nextclass);
			setPrevClass(prevclass);

			if (
				AttemptDetails.element_type === 'W' ||
				AttemptDetails.element_type === 'D' ||
				AttemptDetails.element_type === 'F'
			) {
				l_level = l_quest;
				s_level = s_quest;
				r_level = r_quest;
				w_level = w_quest;
			}
		}
	}, [reviewAnswers, elementName, r_level, w_level, l_level, s_level]);

	useEffect(() => {
		getTTS(reviewAnswers);
	}, [answerList, reviewAnswers]);

	return (
		<Modal
			show={showReview}
			size="lg"
			dialogClassName="modal-90w"
			onHide={() => setShowReview(false)}
			backdrop="static"
			keyboard={false}
			className={headerClass}
		>
			<Modal.Header closeButton>
				<div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
					<Row>
						<div className="col-lg-6 col-xs-12 col-md-9 col-sm-12">
							<h4 className="modal-title">{elementName}</h4>
							<ul className="popup-icons">
								<li>
									<img src={Config.ASSETSPATH + '/img/Reading_B.png'} alt="" /> {r_level}
								</li>
								<li>
									<img src={Config.ASSETSPATH + '/img/Writing_B.png'} alt="" /> {w_level}
								</li>
								<li>
									<img src={Config.ASSETSPATH + '/img/Listening_B.png'} alt="" />
									{l_level}
								</li>
								<li>
									<img src={Config.ASSETSPATH + '/img/Speaking_B.png'} alt="" />{' '}
									{s_level}
								</li>
							</ul>
						</div>
						<div className="col-lg-4 col-xs-12 col-md-3 col-sm-12">
							<h4 className="modal-title">{totalAnswers} Questions</h4>
							<ul className="popup-icons popup-icons-review">
								<li>
									<img src={Config.ASSETSPATH + '/img/review_wrong.png'} alt="" />
									{wrongAnswers}
								</li>
								<li>
									<img src={Config.ASSETSPATH + '/img/review_correct.png'} alt="" />
									{correctAnswers}
								</li>
								<li>
									<img src={Config.ASSETSPATH + '/img/review_ungraded.png'} alt="" />
									{ungradeAnswers}
								</li>
							</ul>
						</div>
						<div className="col-lg-2 col-xs-12 col-md-1 col-sm-12">
							<h4 className="modal-title">{headerRight}</h4>
						</div>
					</Row>
					<span className="testdate_span">
						T{AttemptDetails.attempt_id}, {testDate}
					</span>
				</div>
				<Row>
					<div className="testdate_block">
						<a
							style={{ cursor: 'pointer' }}
							className={prevClass}
							{...onPrev}
							id="prevarrow"
						>
							<img src={Config.ASSETSPATH + '/img/prevarrow.png'} alt="" />
						</a>

						{/*<span>Achieved Score: 0.31 </span>*/}
						<a
							style={{ cursor: 'pointer' }}
							className={nextClass}
							{...onNext}
							id="nextarrow"
						>
							<img src={Config.ASSETSPATH + '/img/nextarrow.png'} alt="" />
						</a>
					</div>
				</Row>
			</Modal.Header>
			<Modal.Body size="lg">
				<div className="row">{answerList}</div>
			</Modal.Body>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	return {
		instrDetails: state.rootReducer.myCourse,
		reviewAttemptDetails: state.rootReducer.myCourse.reviewAttemptDetails,
		courseId: state.rootReducer.loginDetails,
		showReview: state.rootReducer.testPageDetails.showReview,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchAttempt: (attemptId, review = false) =>
			dispatch(fetchAttempt({ attemptId, review })),
		startAttempt: (courseId, elementId) =>
			dispatch(startAttempt({ courseId, elementId })),
		setShowReview: (val) => dispatch(setShowReview(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewAttemptModal);
